import { bluePalette } from '../../../themes/colors';

export const primarySidenavDarkTheme = {
  backgroundColor: bluePalette[1000],
};
